
import {UserCounty} from "./UserCounty";
import {UserRoles} from "./UserRoles";



export class User {
  constructor(
    public id?: number,
    public username?: any,
    public password?: any,
    public firstName?: any,
    public lastName?: any,
    //public userRoles?: UserRoles[],
    public providerId?: number,
    public userCounties?: UserCounty[],
    public beginDt?: any,
    public endDt?: any,
    public recordVersion?: number,
    public tempPassword?: string,
    public tempPasswordSw?: string,
  ){}
}



// WEBPACK FOOTER //
// ./src/app/shared/model/User.ts